import { render, staticRenderFns } from "./page1.vue?vue&type=template&id=17964f18&scoped=true"
import script from "./page1.vue?vue&type=script&lang=js"
export * from "./page1.vue?vue&type=script&lang=js"
import style0 from "./page1.vue?vue&type=style&index=0&id=17964f18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17964f18",
  null
  
)

export default component.exports